import { render, staticRenderFns } from "./BulkCreateItem.vue?vue&type=template&id=58c4cd57&"
import script from "./BulkCreateItem.vue?vue&type=script&lang=js&"
export * from "./BulkCreateItem.vue?vue&type=script&lang=js&"
import style0 from "./BulkCreateItem.vue?vue&type=style&index=0&id=58c4cd57&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports